const endScreenState = {
  data: {
    title: "",
    description: "",
    shareEnabled: true,
    endScreenData: {
      endScreenType: "default",
    },
  },
  etc: {
    endScreenStep: 0,
    isEndScreenSubmittable: false,
    creationType: "",
    endScreenType: "",
  },
};

export default endScreenState;
